module.exports = __webpack_public_path__ + "img/banner_shanghaiMember.af7a9737.png";